import { render, staticRenderFns } from "./ProductToCheck.vue?vue&type=template&id=4837a806&scoped=true&"
import script from "./ProductToCheck.vue?vue&type=script&lang=js&"
export * from "./ProductToCheck.vue?vue&type=script&lang=js&"
import style0 from "./ProductToCheck.vue?vue&type=style&index=0&id=4837a806&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4837a806",
  null
  
)

export default component.exports